import { render } from "./ModalInformativoDocumentosDeclaracoes.vue?vue&type=template&id=d1a36f04"
import script from "./ModalInformativoDocumentosDeclaracoes.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDocumentosDeclaracoes.vue?vue&type=script&lang=js"

import "./ModalInformativoDocumentosDeclaracoes.vue?vue&type=style&index=0&id=d1a36f04&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__